const log = {
    invalid_type: 'The log type is invalid.',
};
export default log;
